/**
 * Fonte ÚNICA da regra que decide em qual etapa do formulário público cada
 * campo aparece. É usada tanto pelo formulário público (que monta as etapas)
 * quanto pelo Form Management (que mostra ao administrador onde a pergunta vai
 * cair) — assim a prévia nunca diverge do resultado real.
 *
 * Regra: os campos são percorridos NA ORDEM definida no Form Management
 * (botões ↑ ↓). Um campo de nome conhecido define a etapa corrente; uma
 * pergunta livre (nome criado pelo cliente) herda a etapa do campo conhecido
 * anterior, aparecendo na posição escolhida. Perguntas livres que ficam depois
 * do último campo conhecido vão para "Informações Adicionais".
 */

export const EXTRA_STEP_TITLE = 'Informações Adicionais';

export const STEPS = [
  { title: 'Identificação', names: ['identificacao', 'nome', 'email', 'telefone'] },
  { title: 'Sobre Quem', names: ['sobre_quem', 'tipo_publico'] },
  { title: 'Detalhes da Denúncia', names: ['tipo_denuncia', 'local_ocorrencia', 'quando_ocorreu', 'departamento'] },
  { title: 'Relato', names: ['relato_detalhado', 'tentou_esconder', 'presenciou_fatos', 'outras_testemunhas', 'evidencias', 'arquivo', 'arquivos'] }
];

const stepIndexOf = (name) => STEPS.findIndex((s) => s.names.includes(name));

/**
 * Para cada campo, o título da etapa em que ele vai aparecer.
 * @param {Array} fields campos na ordem definida pelo administrador
 * @returns {Array<string>} títulos, na mesma ordem dos campos
 */
export const computeFieldStepTitles = (fields) => {
  const list = Array.isArray(fields) ? fields : [];
  const lastKnownIndex = list.reduce((acc, f, i) => (stepIndexOf(f?.name) >= 0 ? i : acc), -1);

  let current = -1;
  return list.map((field, i) => {
    const step = stepIndexOf(field?.name);
    if (step >= 0) {
      current = step;
      return STEPS[step].title;
    }
    if (i > lastKnownIndex) return EXTRA_STEP_TITLE;
    return STEPS[current >= 0 ? current : 0].title;
  });
};

/**
 * Agrupa os campos em etapas, preservando a ordem dentro de cada etapa.
 * @param {Array} fields
 * @returns {Array<{title: string, fields: Array}>} apenas etapas não vazias
 */
export const groupFieldsIntoSteps = (fields) => {
  const list = Array.isArray(fields) ? fields : [];
  const titles = computeFieldStepTitles(list);

  const order = [...STEPS.map((s) => s.title), EXTRA_STEP_TITLE];
  const byTitle = new Map(order.map((t) => [t, []]));
  list.forEach((field, i) => byTitle.get(titles[i]).push(field));

  return order
    .map((title) => ({ title, fields: byTitle.get(title) }))
    .filter((g) => g.fields.length > 0);
};
